import React, { useState } from 'react';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import baseURL from "../config";
import { ShimmerBanner } from './ShimmerCard';

interface BannerProps {
    banner: any[];
    loading: boolean;
}


const BannerImage = ({ src, alt }: { src: string; alt: string }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div className={`relative w-full aspect-[16/7] sm:aspect-[21/9] md:aspect-[3/1] bg-gray-200 overflow-hidden ${!isLoaded ? 'animate-pulse' : ''}`}>
            {/* Loading Skeleton/Spinner */}
            <img
                src={src}
                alt={alt}
                loading="lazy"
                className={`w-full h-full object-cover transition-opacity duration-700 ease-in-out ${isLoaded ? 'opacity-100' : 'opacity-0'
                    }`}
                onLoad={() => setIsLoaded(true)}
            />
        </div>
    );
};

const HomeBanner: React.FC<BannerProps> = ({ banner, loading }) => {
    if (loading) {
        return (
            <ShimmerBanner />
        );
    }

    if (!banner || banner.length === 0) return null;

    const settings = {
        dots: true,
        infinite: banner.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: banner.length > 1,
        autoplaySpeed: 3000,
        arrows: false,
        appendDots: (dots: any) => (
            <div style={{ position: 'absolute', bottom: '10px', width: '100%' }}>
                <ul className="m-0 p-0 flex justify-center gap-[4px]">{dots}</ul>
            </div>
        ),
        customPaging: (i: number) => (
            <div className="w-1.5 h-1.5 bg-white/40 hover:bg-white rounded-full transition-colors cursor-pointer slick-custom-dot mt-1"></div>
        ),
        // fade: true, // Smooth transition
    };

    return (
        <div className="w-full h-full bg-transparent rounded-xl sm:rounded-2xl shadow-md overflow-hidden relative group leading-none flex flex-col">
            <style>{`
                .slick-dots li {
                    margin: 0;
                    width: auto;
                    height: auto;
                }
                .slick-dots li.slick-active .slick-custom-dot {
                    background-color: white !important;
                }
            `}</style>
            <Slider {...settings}>
                {banner.map((b: any) => (
                    <div key={b._id} className="outline-none">
                        <BannerImage src={`${baseURL}/${b.image}`} alt={b.title} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default HomeBanner;
